// Pluralization helpers for expiration strings

// n%10=1 AND n%100≠11 → one; n%10 in [2-4] AND n%100 not in [12-14] → few; else → many (ru, uk, sr, hr, bs)
export const slavic = (n: number, one: string, few: string, many: string) => {
  const t = n % 10;
  const h = n % 100;

  if (t === 1 && h !== 11) return `${n} ${one}`;
  if (t >= 2 && t <= 4 && (h < 10 || h >= 20)) return `${n} ${few}`;

  return `${n} ${many}`;
};

// n=1 → one; n in [2-4] → few; else → many (cs, sk)
export const czech = (n: number, one: string, few: string, many: string) => {
  if (n === 1) return `${n} ${one}`;
  if (n >= 2 && n <= 4) return `${n} ${few}`;

  return `${n} ${many}`;
};

// n=1 → one; n%10 in [2-4] AND n%100 not in [12-14] → few; else → many (pl)
export const polish = (n: number, one: string, few: string, many: string) => {
  if (n === 1) return `${n} ${one}`;
  const t = n % 10;
  const h = n % 100;

  if (t >= 2 && t <= 4 && (h < 10 || h >= 20)) return `${n} ${few}`;

  return `${n} ${many}`;
};

// n=1 → one; n=2 → two; n in [3-4] → few; else → many (sl)
export const slovenian = (n: number, one: string, two: string, few: string, many: string) => {
  if (n === 1) return `${n} ${one}`;
  if (n === 2) return `${n} ${two}`;
  if (n === 3 || n === 4) return `${n} ${few}`;

  return `${n} ${many}`;
};

// n%10=1 AND n%100≠11 → one; else → many (lv)
export const latvian = (n: number, one: string, many: string) => {
  if (n % 10 === 1 && n % 100 !== 11) return `${n} ${one}`;

  return `${n} ${many}`;
};

// n%10=1 AND n%100≠11 → one; n%10 in [2-9] AND n%100 not in [11-19] → few; else → many (lt)
export const lithuanian = (n: number, one: string, few: string, many: string) => {
  const t = n % 10;
  const h = n % 100;

  if (t === 1 && h !== 11) return `${n} ${one}`;
  if (t >= 2 && t <= 9 && (h < 10 || h >= 20)) return `${n} ${few}`;

  return `${n} ${many}`;
};
